import { Injectable } from '@angular/core';
import { AppstorageTsService } from '../appstorage/appstorage.ts.service';
import { Platform } from '@ionic/angular';
import { ConfigService } from '../config/config.service';
import { Navigator } from 'src/app/components/menu/navigator';
import { UserSessionService } from '../user-session/user-session.service';
import { LogoutService } from '../logout/logout.service';
import { MobileToolsService } from '../mobile-tools/mobile-tools.service';

@Injectable({
  providedIn: "root",
})
export class SiteLocationService {

  statesMap: { [key: string]: string } = {
    'ON': 'Ontario',
  }

  statesRgLogoMap: { [key: string]: string } = {
    'Ontario': 'imgs/rg_on.svg',
  }

  constructor(
    private platform: Platform,
    private appstorageTsService: AppstorageTsService,
    private navigator: Navigator,
    private config: ConfigService,
    public userSession: UserSessionService,
    private mobileTools: MobileToolsService,
    private logoutService: LogoutService
  ) { }


  public goTo(url?, stateCode?, environment?) {
    console.log("SiteLocationService goTo", url, stateCode, environment)
        this.config.reloadConfig(environment).then(() => {
          return setTimeout(() => {
            console.log("skin: jurisdiction change ", stateCode);
            this.navigator.toHomePage();

            this.mobileTools.checkRestrictedPlayStore().then(() => {
              console.log("show play store restricted?", this.mobileTools.shouldRestrictPlayStore)

              if (!this.mobileTools.shouldRestrictPlayStore) {
                this.mobileTools.checkForUpdate().then(() => {
                  console.log("show update?", this.mobileTools.shouldUpdate)
                })
              }
            })

          }, 1000);
      });
    
  }
  //called from the menu
  changeState(url, stateCode) {
    this.userSession.isAuthenticated().then(async (isAuthenticated) => {
      if (this.platform.is("capacitor")) {
        await this.appstorageTsService.setFallsviewJurisdiction(stateCode);
        if (!isAuthenticated) {
          this.navigator.toLobby();
        }
      }

      if (isAuthenticated) {
        this.logoutService.callLogout();
      }
      if (!this.platform.is("capacitor")) {
        setTimeout(() => {
          this.goTo(url, stateCode);
        }, 1000);
      }
    });
  }
}
